<img loading="lazy" class="email-character" src="./../../../assets/images/i-email.png" alt="">
<p class="text-title-md-bold text-center">Por favor confirma tu correo electrónico</p>
<p class="text-info mt-xxs text-center">Con esto nos ayudas a mantener tu cuenta segura.</p>
<form #form class="inputs-code mt-xlg" (input)="handleInput($event)">
  <input
    #ngInputOne
    [ngModelOptions]="{standalone: true}"
    maxlength="1" 
    pattern="[0-9]" 
    class="input-code text-title-lg" 
    [class.invalid]="isValidate && !this.inputCodeOne"
    [(ngModel)]="this.inputCodeOne" 
    (paste)="handlePaste($event)"
    (focus)="onFocus($event)"
    (keydown)="handleKeyDown($event)" type="text" nz-input>

  <input
    #ngInputTwo
    [ngModelOptions]="{standalone: true}"
    maxlength="1" 
    pattern="[0-9]" 
    class="input-code text-title-lg" 
    [class.invalid]="isValidate && !this.inputCodeTwo" 
    [(ngModel)]="this.inputCodeTwo" 
    (paste)="handlePaste($event)"
    (focus)="onFocus($event)"
    (keydown)="handleKeyDown($event)" type="text" nz-input>

  <input
    #ngInputThree
    [ngModelOptions]="{standalone: true}"
    maxlength="1" 
    pattern="[0-9]"
    class="input-code text-title-lg"
    [class.invalid]="isValidate && !this.inputCodeThree" 
    [(ngModel)]="this.inputCodeThree" 
    (paste)="handlePaste($event)"
    (focus)="onFocus($event)"
    (keydown)="handleKeyDown($event)" type="text" nz-input>

  <input
    #ngInputFour
    [ngModelOptions]="{standalone: true}"
    maxlength="1" 
    pattern="[0-9]" 
    class="input-code text-title-lg" 
    [class.invalid]="isValidate && !this.inputCodeFour" 
    [(ngModel)]="this.inputCodeFour" 
    (paste)="handlePaste($event)"
    (focus)="onFocus($event)"
    (keydown)="handleKeyDown($event)" type="text" nz-input>

</form>
